import * as React from "react";
import type { SVGProps } from "react";
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.6 15.22v3.706c0 .561.221 1.1.615 1.497s.928.62 1.485.62h12.6a2.1 2.1 0 0 0 1.485-.62c.394-.397.615-.936.615-1.497V15.22m-8.357-.263v-12m0 0-4.8 4.585m4.8-4.585 4.8 4.585"
    />
  </svg>
);
export default SvgShare;
